import React, { Component } from "react";
import { handleKeyPress } from "../../../helpers/KeyPressHelper";

class TooltipIcon extends Component {
  render() {


      return (
      <i
        className={(this.props.mfa? "icon-info-mfa " : "icon-info-blue ")+this.props.customStyle}
        aria-label={this.props.ariaLabel}
        tabIndex="0"
        role="button"
        onClick={this.props.onToggle}
        onKeyPress={(e) => {
          handleKeyPress(e, this.props.onToggle);
        }}
      />
    );
    


    
  }
}

export default TooltipIcon;
